document.addEventListener('DOMContentLoaded', function() {
  const overlay = document.getElementById('save100-popup-overlay');
  const closeBtn = document.getElementById('save100-close-btn');

  if (!overlay || !closeBtn) return;

  // Retrieve current active counts assigned to this session instance
  let shownCount = parseInt(sessionStorage.getItem('save100_shown_count')) || 0;

  // Enforce boundary logic rule: run only if shown less than twice
  if (shownCount < 6) {
    // 1.5 second delay before popup reveals for a better browsing experience
    setTimeout(function() {
      overlay.classList.add('s100-active');
      
      // Immediately increment the session count upon successful display
      shownCount++;
      sessionStorage.setItem('save100_shown_count', shownCount);
    }, 1500);
  }

  // Close Event Logic
  function closePopup() {
    overlay.classList.remove('s100-active');
  }

  // Close when hitting the Cross (X) icon
  closeBtn.addEventListener('click', closePopup);

  // Close if user clicks outside on the darkened overlay background shadow
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      closePopup();
    }
  });
});